<template>
    <div class="absolute inset-0">
        <!-- Overlay. -->
        <div class="absolute inset-0 bg-gray-700 transition-opacity duration-300" :class="overlayClass"></div>

        <!-- Content. -->
        <div class="absolute inset-y-0 right-0 w-full transition-opacity duration-300" :class="sidepageSize"
             @mousedown="(e) => {!this.goTransparent||this.$refs['toggler'].contains(e.target)?null:transparentOff()}">
            <on-click-outside :do="() => {this.goTransparent&&this.transparent?transparentOff():close()}">
                <on-keydown :condition="key => key === 'Escape'"
                            :do="() => {this.goTransparent&&this.transparent?transparentOff():close()}">
                    <on-keydown :condition="(key,alt,ctrl,shift) => shift && (key === ' ')"
                                :do="() =>{this.goTransparent&&this.transparent?transparentOff():transparentOn()}">
                        <div class="relative bg-white h-full shadow-xl overflow-y-auto p-4 sm:p-6" role="dialog"
                             aria-modal="true" aria-labelledby="sidepage-headline">
                            <div class="absolute top-4 right-4">
                                <button @click="close"
                                        class="p-1.5 border border-gray-300 bg-white hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="text-gray-400 h-5 w-5" fill="none"
                                         viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M6 18L18 6M6 6l12 12"/>
                                    </svg>
                                </button>
                                <div class="text-gray-400 text-center mt-0.5 font-medium" style="font-size: 9px;">ESC
                                </div>
                            </div>
                            <div class="absolute top-4 right-16" v-if="goTransparent">
                                <div
                                    class="p-1 border border-gray-300 bg-white w-13 rounded-md">
                                <span
                                    role="checkbox"
                                    tabindex="0"
                                    ref="toggler"
                                    aria-checked="false"
                                    class="relative cursor-pointer inline-block flex-shrink-0 m-0.5 h-5 w-10 border-2 border-transparent rounded-full transition-colors focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                                    :class="transparent ? 'bg-gray-800' : 'bg-gray-200'"
                                    @click="transparent?transparentOff():transparentOn()"
                                    @change="transparent?transparentOff():transparentOn()"
                                >
                                    <span
                                        aria-hidden="true"
                                        class="inline-block h-4 w-4 rounded-full bg-white shadow transform transition"
                                        :class="transparent ? 'translate-x-5' : 'translate-x-0'"
                                    ></span>
                                </span>
                                </div>
                                <div class="text-gray-400 text-center mt-0.5 font-medium" style="font-size: 9px;">
                                    SHIFT+SPACE
                                </div>
                            </div>

                            <slot name="header">
                                <div v-if="title" class="mb-6 mr-12">
                                    <h3
                                        class="text-lg leading-6 font-medium text-gray-900 truncate"
                                        id="sidepage-headline"
                                        v-text="title"
                                    ></h3>
                                    <p v-if="subtitle" v-text="subtitleAsLine"
                                       class="mt-1 text-sm text-gray-500 truncate"></p>
                                </div>
                            </slot>

                            <slot></slot>
                        </div>
                    </on-keydown>
                </on-keydown>
            </on-click-outside>
        </div>
    </div>
</template>

<script>
import {toLine} from '@utils'
import OnMouseDownOutside from "./OnMouseDownOutside";
import OnClickOutside from "./OnClickOutside";
import UiToggle from "./UiToggle.vue";

export default {
    components: {UiToggle, OnClickOutside, OnMouseDownOutside},
    props: {
        title: String,
        subtitle: String | Array,
        large: Boolean,
        extraLarge: Boolean,
        close: Function,
        open: Function,
        goTransparent: false,
    },
    data() {
        return {
            transparent: null,
        }
    },
    methods: {
        transparentOn(e) {
            this.transparent = true;
        },
        transparentOff() {
            this.transparent = false;
        },
    },
    computed: {
        overlayClass() {
            return this.goTransparent && this.transparent ? 'opacity-0' : 'opacity-75'
        },
        sidepageSize() {
            let cls = this.goTransparent && this.transparent ? 'opacity-20 ' : ''
            if (this.extraLarge) return cls + 'sm:max-w-screen-lg'
            if (this.large) return cls + 'sm:max-w-3xl'
            return cls + 'sm:max-w-md'
        },
        subtitleAsLine() {
            return toLine(this.subtitle)
        }
    },
}
</script>
